import React from 'react'

export function ContentBoxedHeader (props) {
  const { children } = props
  return <div className="profile-section-title">{children}</div>
}

export default ContentBoxedHeader
